import React from 'react';

const HeaderNavigation = ({
    activePage,
    onNavigate,
    user,
    userProfile,
    onSignOut,
    onOpenAuth, // تابع باز کردن مودال ورود (می‌تواند mode بگیرد: 'login' یا 'signup')
    mobileMenuHidden,
    setMobileMenuHidden,
    Icons
}) => {
    
    // اگر در صفحه ادمین هستیم، نوار نویگیشن را نمایش نده
    if (activePage === 'admin-panel') {
        return null;
    }

    // تابع کمکی برای هندل کردن نویگیشن و بستن منوی موبایل به صورت همزمان
    const handleNavClick = (page, section = null) => {
        onNavigate(page, section);
        setMobileMenuHidden(true); // بستن منوی موبایل بعد از کلیک
    };

    return (
      <header className="fixed w-full z-50 top-0 transition-all duration-300 glass-panel shadow-lg">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
            {/* Logo */}
            <div className="flex items-center gap-3 cursor-pointer" onClick={() => handleNavClick('home')}>
                <img 
                    src="https://arkaniomran.ir/images/Logo.png" 
                    alt="Logo" 
                    className="w-20 h-20 object-contain rounded-lg transform rotate-3 hover:rotate-0 transition-transform"
                    onError={(e) => {
                        e.target.style.display = 'none';
                    }}
                />
                <div>
                    <h1 className="text-xl font-bold tracking-tight text-white">ارکانی عمران</h1>
                    <span className="text-xs text-slate-400 block -mt-1 tracking-wider">Arkani Omran</span>
                </div>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden md:flex gap-4 lg:gap-6 text-xs lg:text-sm font-medium items-center">
                <button 
                    onClick={() => onNavigate('home')} 
                    className={`hover:text-yellow-500 transition-colors ${activePage === 'home' ? 'text-yellow-500' : ''}`}
                >
                    خانه
                </button>
                
                {/* دکمه آموزش ایتبس فولادی */}
                <button 
                    onClick={() => onNavigate('etabs-training')} 
                    className={`hover:text-red-400 transition-colors flex items-center gap-1 ${activePage === 'etabs-training' ? 'text-red-400 font-bold' : ''}`}
                >
                    آموزش ایتبس فولادی
                    {/* نقطه چشمک زن برای جلب توجه */}
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                    </span>
                </button>

                {/* دکمه جدید آموزش ایتبس بتنی */}
                <button 
                    onClick={() => onNavigate('etabs-concrete-training')} 
                    className={`hover:text-amber-400 transition-colors flex items-center gap-1 ${activePage === 'etabs-concrete-training' ? 'text-amber-400 font-bold' : ''}`}
                >
                    آموزش ایتبس بتنی
                    {/* نقطه چشمک زن برای جلب توجه */}
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
                    </span>
                </button>

				{/* دکمه جدید آموزش سیف */}
                <button 
                    onClick={() => onNavigate('safe-training')} 
                    className={`hover:text-blue-400 transition-colors flex items-center gap-1 ${activePage === 'safe-training' ? 'text-blue-400 font-bold' : ''}`}
                >
                    آموزش سیف
                    {/* نقطه چشمک زن برای جلب توجه */}
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                    </span>
                </button>
				
				{/* دکمه جدید آموزش آیدیا استاتیکا */}
                <button 
                    onClick={() => onNavigate('IdeaStatica-training')} 
                    className={`hover:text-purple-400 transition-colors flex items-center gap-1 ${activePage === 'IdeaStatica-training' ? 'text-purple-400 font-bold' : ''}`}
                >
                    آموزش آیدیا استاتیکا
                    {/* نقطه چشمک زن برای جلب توجه */}
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-500"></span>
                    </span>
                </button>

                <button 
                    onClick={() => onNavigate('free-apps')} 
                    className={`hover:text-yellow-300 transition-colors border border-yellow-500/40 bg-yellow-500/5 hover:bg-yellow-500/10 px-3 py-1.5 rounded-lg shadow-[0_0_10px_rgba(234,179,8,0.2)] ${activePage === 'free-apps' ? 'text-yellow-500' : 'text-yellow-500'}`}
                >
                    برنامه‌های رایگان
                </button>
                <button 
                    onClick={() => onNavigate('home', 'products-section')} 
                    className="hover:text-yellow-500 transition-colors"
                >
                    محصولات
                </button>
                <button 
                    onClick={() => onNavigate('forum')} 
                    className={`hover:text-yellow-500 transition-colors flex items-center gap-1 ${activePage === 'forum' ? 'text-yellow-500' : ''}`}
                >
                    تالار گفت‌و‌گو
                </button>
                <button 
                    onClick={() => onNavigate('news')} 
                    className={`hover:text-yellow-500 transition-colors ${activePage === 'news' ? 'text-yellow-500' : ''}`}
                >
                    اخبار
                </button>
                <button 
                    onClick={() => onNavigate('about')} 
                    className={`hover:text-yellow-500 transition-colors ${activePage === 'about' ? 'text-yellow-500' : ''}`}
                >
                    درباره ما
                </button>
                
                {/* User Status / Login Button */}
                {user ? (
                   <div className="flex items-center gap-3 border-r border-slate-700 pr-4">
                      <div className="flex flex-col text-right">
                          <span className="text-yellow-500 text-xs font-bold truncate max-w-[100px]">
                              {userProfile?.username || 'کاربر'}
                          </span>
                          <button 
                              onClick={onSignOut} 
                              className="text-slate-400 text-[10px] hover:text-red-400 text-right"
                          >
                              خروج
                          </button>
                      </div>
                      <div className="w-8 h-8 rounded-full bg-slate-800 border border-yellow-500/50 flex items-center justify-center text-yellow-500">
                         <Icons.User size={16} />
                      </div>
                   </div>
                ) : (
                  <button 
                      onClick={() => onOpenAuth('login')} 
                      className="bg-yellow-500 text-slate-900 px-4 py-2 rounded-full font-bold hover:bg-yellow-400 transition-transform hover:scale-105"
                  >
                      ورود
                  </button>
                )}
            </nav>

            {/* Mobile Menu Button */}
            <button className="md:hidden text-white p-2" onClick={() => setMobileMenuHidden(!mobileMenuHidden)}>
                <Icons.Menu />
            </button>
        </div>
        
        {/* Mobile Menu */}
        <div id="mobile-menu" className={`${mobileMenuHidden ? 'hidden' : ''} md:hidden bg-slate-900 border-t border-slate-800 p-4 absolute w-full left-0 shadow-xl z-40`}>
            <div className="flex flex-col gap-4 text-center">
                {user && (
                    <div className="bg-slate-800/50 p-3 rounded-lg flex items-center justify-between mb-2">
                         <div className="flex items-center gap-2">
                             <Icons.User size={18} className="text-yellow-500" />
                             <span className="text-white text-sm">{userProfile?.username || 'کاربر'}</span>
                         </div>
                         <button onClick={onSignOut} className="text-red-400 text-xs bg-red-500/10 px-2 py-1 rounded">خروج</button>
                    </div>
                )}
                
                <button onClick={() => handleNavClick('home')} className="py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors">خانه</button>
                
                {/* آیتم موبایل آموزش ایتبس فولادی */}
                <button onClick={() => handleNavClick('etabs-training')} className="py-2 border-b border-slate-800 text-red-400 font-bold hover:bg-red-500/10 transition-colors flex items-center justify-center gap-2">
                    آموزش جامع ایتبس فولادی
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500"></span>
                    </span>
                </button>

                {/* آیتم موبایل آموزش ایتبس بتنی */}
                <button onClick={() => handleNavClick('etabs-concrete-training')} className="py-2 border-b border-slate-800 text-amber-400 font-bold hover:bg-amber-500/10 transition-colors flex items-center justify-center gap-2">
                    آموزش جامع ایتبس بتنی
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-amber-500"></span>
                    </span>
                </button>
				
				{/* آیتم موبایل آموزش سیف */}
                <button onClick={() => handleNavClick('safe-training')} className="py-2 border-b border-slate-800 text-red-400 font-bold hover:bg-red-500/10 transition-colors flex items-center justify-center gap-2">
                    آموزش جامع سیف
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-500"></span>
                    </span>
                </button>
				{/* آیتم موبایل آموزش آیدیا استاتیکا */}
                <button onClick={() => handleNavClick('IdeaStatica-training')} className="py-2 border-b border-slate-800 text-red-400 font-bold hover:bg-red-500/10 transition-colors flex items-center justify-center gap-2">
                    آموزش جامع آیدیا استاتیکا
                    <span className="relative flex h-2 w-2">
                      <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-purple-400 opacity-75"></span>
                      <span className="relative inline-flex rounded-full h-2 w-2 bg-purple-500"></span>
                    </span>
                </button>




                <button onClick={() => handleNavClick('free-apps')} className="py-2 border-b border-slate-800 text-yellow-500 font-bold hover:bg-yellow-500/5 transition-colors">برنامه‌های رایگان</button>
                <button onClick={() => handleNavClick('home', 'products-section')} className="py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors">محصولات</button>
                <button onClick={() => handleNavClick('forum')} className="py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors">تالار گفت‌و‌گو</button>
                <button onClick={() => handleNavClick('news')} className="py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors">اخبار</button>
                <button onClick={() => handleNavClick('about')} className="py-2 border-b border-slate-800 hover:text-yellow-500 transition-colors">درباره ما</button>
                
                {!user && (
                    <button 
                        onClick={() => { onOpenAuth('login'); setMobileMenuHidden(true); }} 
                        className="text-yellow-500 py-2 font-bold hover:text-yellow-400 transition-colors border border-yellow-500/20 rounded-lg"
                    >
                        ورود / ثبت‌نام
                    </button>
                )}
            </div>
        </div>
      </header>
    );
};

export default HeaderNavigation;